/**
 * App Config File
 */
// var domain = 'http://127.0.0.1:8000/';
// var domain = 'https://cusapi.cypheme.com/';
var domain = 'https://cusapi.cypheme.com/';
// var domain = 'https://stagingapi.cypheme.com/';
// var domain = 'http://cypheme.localhost.com/';
// var domain = 'https://cypheme-api.esipick.com/';
export default {
	jane: domain,
	janeAPI: domain+'api/v1/'
}
